module.exports = __webpack_public_path__ + "assets/img/ko-09beb4fe.png";